import { render, staticRenderFns } from "./SystemComponentDelete.vue?vue&type=template&id=68a0eda8&"
import script from "./SystemComponentDelete.vue?vue&type=script&lang=js&"
export * from "./SystemComponentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports